import _, { noop } from 'lodash';
import PropTypes from 'prop-types';
import React from 'react';
import { RepoItem } from '../../autogenerated/ZoomBridge';
import t from '../../i18n/I18n';
import Popover from '../../Popover';
import { showSuccessMsg } from '../../store/StoreUtil';
import { ACTION_MODALS } from '../../util/Constants';
import Portal from '../Portal';
import './MorePopover.css';
import { DATA_CM } from './util/util_CM';
import Option_CM from './options/Option_CM';
import Popover_CM from './portals/Popover_CM';
import ActionUtil_CM from './util/actionUtil_CM';
import ViewUtil from '../../ViewUtil';

export default class MorePopover extends React.PureComponent {
  portalElement: HTMLDivElement = null;

  static propTypes = {
    top: PropTypes.any,
    bottom: PropTypes.any,
    left: PropTypes.any,
    right: PropTypes.any,
    height: PropTypes.any,
    width: PropTypes.any,
    backgroundImage: PropTypes.any,
    asset: PropTypes.object,
    iconStyle: PropTypes.object,
    onDeleteSuccess: PropTypes.func,
    showAssetDetail: PropTypes.func,
    permission: PropTypes.object,
    onMenuClose: PropTypes.func,
    onMenuOpen: PropTypes.func,
    fetchAssets: PropTypes.func,
    onRenameSuccess: PropTypes.func,
    showPopover: PropTypes.any,
    onRefreshPWD: PropTypes.func,
    extDetails: PropTypes.object,
    onRefresh: PropTypes.func,
    closeContextMenu: PropTypes.func,
    showIcon: PropTypes.bool,
    collection: PropTypes.object
  };

  static defaultProps = {
    onMenuClose: noop,
    onMenuOpen: noop,
    onPopoverOpen: noop,
    onPopoverClose: noop,
    onRemoveFromCollectionClick: noop,
    // backgroundImage: 'url(images/more.svg)',
    showPopover: false,
    closeContextMenu: noop,
    extDetails: {}
  };

  //containsFolder = undefined;
  //containFiles = undefined;
  containWCFile = undefined;
  contextMenuCall: boolean = undefined;
  state = {
    showPopover: false,
    modal: ACTION_MODALS.NULL
  };

  componentDidUpdate(prevProps, prevState) {
    //Todo: need to check it's doing continuous calls to the popover.
    if (this.state.showPopover && !prevState.showPopover) this.props.onMenuOpen();
    else if (!this.state.showPopover && prevState.showPopover) this.props.onMenuClose();

    if (prevState.modal == null && this.state.modal != null) this.props.onPopoverOpen();
    else if (prevState.modal != null && this.state.modal == null) this.props.onPopoverClose();
  }

  componentDidMount() {
    this.selectedAssets = undefined;
    this._isMounted = true;
  }

  componentWillUnmount() {
    this._isMounted = false;
    this.props.onMenuClose();
    this.props.onPopoverClose();
  }

  setStateOnMountCheck(state) {
    if (this._isMounted) {
      this.setState(state);
    }
  }

  getAssets = () => {
    const { assets } = this.props;
    if (assets && assets.length) {
      return assets;
    }
    if (!this.selectedAssetsCache) {
      const assets: Array<RepoItem> = [];
      if (window.gs.selectedAssets?.length) {
        const selected: Array<RepoItem> = window.gs.selectedAssets;
        if (selected && selected.length) assets.push(...selected);
        else if (this.props.asset) assets.push(this.props.asset);
      }
      else if (this.props.asset) {
        assets.push(this.props.asset);
      }
      this.selectedAssetsCache = assets;
    }
    return this.selectedAssetsCache;
  };


  onRef = (element: ?HTMLDivElement) => {
    if (!element) {
      return;
    }
    this.portalElement = element.parentNode;
    if (this.portalElement) {
      this.portalElement.onmousedown = (e) => {
        if (e.which === 3) {
          this.onClose();
        }
      };
    }
    if (this.props.showPopover) {
      getPosition(element, this.props.showPopover.screenX, this.props.showPopover.screenY);
    } else {
      const domElement = this.refs.icon.getBoundingClientRect();
      getPosition(element, domElement.x, domElement.y);
    }
  };

  onClose = () => {
    const { closeContextMenu } = this.props;
    this.setState({ showPopover: false });
    if (closeContextMenu) closeContextMenu();
  };

  setModalToOnClose = (isEventOrBool) => {
    this.setState({ modal: ACTION_MODALS.NULL });
    if (typeof (isEventOrBool) === 'boolean') {
      this.props.onRefreshPWD ? this.props.onRefreshPWD() : null;
    }
  }

  onCloseContextMenu = () => {
    const { closeContextMenu, onRefreshPWD } = this.props;
    // if(onRefreshPWD) onRefreshPWD();
    closeContextMenu();
  }

  render() {
    const { modal } = this.state;
    const { top, left, right, bottom, width, height, backgroundImage, extDetails, onRefreshPWD, onRenameSuccess, onDeleteSuccess, onRefresh, setShowInfoMetadata, showIcon = false, collection, selectedCollections } = this.props;
    this.selectedAssetsCache = undefined;
    const assets = this.getAssets();
    let actionKeys = [];
    let excludedActionList: Array<String> = [];
    const actionUtil_CM_Obj: ActionUtil_CM = ActionUtil_CM.getInstance();
    if (ViewUtil.isCollectionTabActive() && assets.length == 0) {
      actionKeys = DATA_CM.COLLECTION_KEYS;
    }
    else if (ViewUtil.isCollectionTabActive() && assets.length > 0) {
      actionKeys = DATA_CM.COLLECTION_ASSETS_KEYS;
    }
    else if (assets) {
      excludedActionList = actionUtil_CM_Obj.getExcludedActions(assets);
      actionKeys = assets && assets.length ? deepDifference(DATA_CM.KEYS, excludedActionList) : DATA_CM.KEYS;
      actionKeys = actionUtil_CM_Obj.getFinalActionList(actionKeys, excludedActionList);
    }
    if (ViewUtil.isBrowseExternalTabActive()) {
      actionKeys = !_.isEmpty(extDetails) ? DATA_CM.EXTERNAL_FILE_KEYS : actionKeys;
    }
    /*const moreActionsKeys = assets && assets.length ? _.difference(DATA_CM.MORE_KEYS, excludedActionList) : DATA_CM.MORE_KEYS;
    const moreIndex = actionKeys.findIndex(option => typeof option === 'object' && option.key === "More")
    if (moreIndex >= 0 && actionKeys[moreIndex])
      actionKeys[moreIndex].value = moreActionsKeys
    // console.log("Action keys : ", actionKeys);
    const externalAssetActionsKeys = assets && assets.length ? _.difference(DATA_CM.MANGE_EXTERNAL_FILE_KEYS, excludedActionList) : DATA_CM.MANGE_EXTERNAL_FILE_KEYS;
    const eAIndex = actionKeys.findIndex(option => typeof option === 'object' && option.key === t("MANAGE_EXTERNAL_ASSET"))
    if (eAIndex !== undefined && actionKeys[eAIndex])
      actionKeys[eAIndex].value = externalAssetActionsKeys*/
    return (
      <div name="MorePopover" onClick={(event) => event.stopPropagation()}>
        {showIcon ? <div
          ref="icon"
          className="icon"
          onClick={(event) => {
            this.setState({ showPopover: !this.state.showPopover }, () => {
              if (!this.state.showPopover) {
                this.props.closeContextMenu();
              } else {
                if (this.props.isPopOverOpen) {
                  this.props.isPopOverOpen(true);
                }
              }
            });
            event.stopPropagation();
            return false;
          }}
          style={{
            ...styles.moreIcon,
            top,
            left,
            right,
            bottom,
            width,
            height,
            backgroundImage,
            ...this.props.iconStyle
          }}
        /> : null
        }

        {
          this.state.showPopover || this.props.showPopover ? (
            <Portal defaultOpen={true} closeOnEsc={true} closeOnOutsideClick={true} onClose={this.onClose}>
              <Popover getRef={this.onRef} onClose={this.onClose}>
                <Option_CM
                  actions={actionKeys}
                  assets={assets}
                  setShowInfoMetadata={setShowInfoMetadata}
                  onRefresh={onRefresh}
                  extDetails={extDetails}
                  getProgressOnQuery={this.getProgressOnQuery}
                  closeContextMenu={this.onCloseContextMenu}
                  setModal={
                    (modal) => {
                      this.setState({ modal });
                    }
                  }
                  collection={collection}
                  selectedCollections={selectedCollections}
                />
              </Popover>
            </Portal>
          ) : null
        }
        {
          modal ? (
            <Popover_CM
              modal={modal}
              title={t('UPLOAD_FROM_URL')}
              asset={assets[0]}
              assets={assets}
              extDetails={extDetails}
              excludedActions={excludedActionList}
              onRefreshPWD={onRefreshPWD}
              onClose={this.setModalToOnClose}
              fetchAssets={onRenameSuccess}
              onDeleteSuccess={onDeleteSuccess}
              getProgressOnQuery={this.getProgressOnQuery}
              message={this.state.message || 0}
              loaded={this.state.progress || 0}
              collections={selectedCollections && selectedCollections.length > 1 ? selectedCollections : [collection]}
              reloadCollection={(fetchFullList) => this.props.reloadCollection(fetchFullList)}
            />
          ) : null
        }
      </div>
    );
  }

  getProgressOnQuery = (progress, message, status = '', showMsg = true) => {
    if (progress < 0) {
      progress = 0;
    }
    if (this.queryStatus !== status) {
      this.queryStatus = status;
      status === '' || status === null
        ? this.setStateOnMountCheck({ modal: DATA_CM.PORTALS.BLANK.MODAL })
        : status === 'RUNNING'
          ? this.setStateOnMountCheck({ modal: DATA_CM.PORTALS.PROGRESS_DIALOG.MODAL })
          : '';
    }
    if (status === 'RUNNING') this.setStateOnMountCheck({ progress, message });
    else {
      this.setStateOnMountCheck({ modal: ACTION_MODALS.NULL });
      if (showMsg) {
        showSuccessMsg(message ? message : t('COMPLETED_SUCCESSFULLY'));
      }
    }
  };
}

MorePopover.reasonableMargin = 300;
MorePopover.reasonableHeightMarcgin = 100;

const styles = {
  moreIcon: {
    position: 'absolute',
    borderRadius: '50%',
    boxShadow: '0 1px 4px 0 rgba(0,0,0,0.04)',
    backgroundPosition: 'center',
    backgroundRepeat: 'no-repeat',
    backgroundSize: '80%',
    cursor: 'pointer'
  }
};

function getPosition(rect, clientX, clientY) {
  const clickX = clientX;
  const clickY = clientY;
  const screenW = window.innerWidth;
  const screenH = window.innerHeight;
  const rootW = rect.offsetWidth;
  const rootH = rect.offsetHeight;
  const right = screenW - clickX > rootW;
  const left = !right;
  const top = screenH - clickY > rootH;
  let moveTop = screenH - clientY;
  // if (clickY < rootH) {
  //   moveTop = rootH - clickY;
  // }
  const bottom = !top;
  if (right) rect.style.left = `${clickX + 5}px`;
  if (left) rect.style.left = `${clickX - rootW - 5}px`;
  if (top) rect.style.top = `${clickY + 5}px`;
  if (bottom) rect.style.top = `${clickY - rootH + moveTop}px`;
}

function deepDifference(array, values) {
  if (!Array.isArray(array)) {
    throw new TypeError('First argument must be an array');
  }

  if (!Array.isArray(values)) {
    throw new TypeError('Second argument must be an array');
  }

  const result = [];

  const valuesSet = new Set(values);

  for (let item of array) {
    if (typeof item === 'object' && item !== null && item.hasOwnProperty('key')) {
      const itemKey = item.key;
      if (!valuesSet.has(itemKey)) {
        result.push(item);
      }
    } else {
      if (!valuesSet.has(item)) {
        result.push(item);
      }
    }
  }

  return result;
}